import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

export default class DropdownOptionAPI {
    public static async getAll() {
        let dropdownOptions;

        try {
            dropdownOptions = (await ApiController.get(ApiRoutes.dropdownOption.get)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(dropdownOptions);
    }
}
